import { ExclamationCircleIcon as ExclamationCircleIconOutline } from '@heroicons/react/24/outline';
import { Checkbox as CheckboxComponent } from '@praetorian-chariot/ui';
import { useState } from 'react';

import { InputEvent, InputProps } from '@/components/form/Input';
import { Tooltip } from '@/components/Tooltip';
import { cn } from '@/utils/classname';

const isCheckedValue = (v: string | number | boolean | undefined): boolean =>
  v === true || v === 'true';

export const Checkbox = (props: InputProps) => {
  const { value, onChange, name, label, disabled, onClick, info, className } =
    props;
  const [showInfo, setShowInfo] = useState(false);

  // Derive checked state from value during render (controlled component)
  const isChecked = isCheckedValue(value as string);

  const handleChange = () => {
    const newValue = !isChecked;

    onChange({
      target: {
        value: newValue,
        name,
      },
    } as unknown as InputEvent);
  };

  return (
    <>
      <div className="flex items-center gap-1">
        <label
          className="flex items-center gap-2"
          data-testid="checkbox-label"
          role="checkbox"
          aria-checked={isChecked}
          aria-disabled={disabled}
        >
          <input
            type="checkbox"
            className={cn('hidden', isChecked ? 'isChecked' : 'isUnchecked')}
            checked={isChecked}
            onChange={handleChange}
            disabled={disabled}
            onClick={onClick}
          />
          <CheckboxComponent isChecked={isChecked} disabled={disabled} />
          <span
            className={cn(
              'text-chariot-text-primary block text-sm leading-6 font-medium',
              className
            )}
          >
            {label}
          </span>
        </label>
        {info && (
          <Tooltip placement="right" title={info?.text}>
            <ExclamationCircleIconOutline
              className="text-chariot-text-primary size-4"
              aria-hidden="true"
              onClick={() =>
                info.url ? window.open(info.url) : setShowInfo(info => !info)
              }
            />
          </Tooltip>
        )}
      </div>
      {info && info.content && showInfo && (
        <div
          className={
            'bg-chariot-background-secondary text-chariot-text-primary mt-2 rounded p-2 text-sm'
          }
        >
          {info.content}
        </div>
      )}
    </>
  );
};
